module.exports = __webpack_public_path__ + "img/i2.53d0b0f3.png";